import { EState } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/types";
import { BasicDurations } from "app/services/DurationService";

export const resolveState = (params): EState => {
    const { comparedDuration } = params;
    const isPeriodOverPeriod = Boolean(comparedDuration);
    if (!isPeriodOverPeriod) {
        return EState.DEFAULT;
    }
    return comparedDuration === BasicDurations.LAST_TWELVE_MONTHS ? EState.YEAR_OVER_YEAR : EState.PERIOD_OVER_PERIOD;
};
